/**
 * company模块接口列表
 */
import axios from './utils/https' // 导入http中创建的axios实例

const company = {
  getCompanys (params) {
    return axios.get('/api/Company/GetCompanys', { params })
  },
  getCompany (params) {
    return axios.get('/api/Company/GetCompany', { params })
  },
  editCompanyInfo (params) {
    return axios.post('/api/Company/EditCompanyInfo', params)
  },
  deleteCompany (params) {
    return axios.delete('/api/Company/DeleteCompany', { params })
  }
}

export default company
